import { logDispatcher } from 'src/app/core/decorators/state.decorators';
import {
  StudentScholarshipData,
  UpdateStudentScholarshipData,
} from '../models/student-scholarship-data.model';

export namespace ScholarshipActions {
  @logDispatcher
  export class AddStudentScholarship {
    static readonly type = '[Scholarships] AddStudentScholarship';
    constructor(public user: string) {}
  }

  @logDispatcher
  export class AddStudentScholarshipSuccess {
    static readonly type = '[Scholarships] AddStudentScholarshipSuccess';
    constructor(public studentScholarshipId: number) {}
  }

  @logDispatcher
  export class EditStudentScholarship {
    static readonly type = '[Scholarships] EditStudentScholarship';
    constructor(
      public updateStudentScholarshipData: UpdateStudentScholarshipData, public studentScholarshipData: StudentScholarshipData, public user: string) {}
  }

  @logDispatcher
  export class EditStudentScholarshipSuccess {
    static readonly type = '[Scholarships] EditStudentScholarshipSuccess';
    constructor(public studentScholarshipData: StudentScholarshipData) {}
  }

  @logDispatcher
  export class DeleteStudentScholarship {
    static readonly type = '[Scholarships] DeleteStudentScholarship';
    constructor(public studentId: number, public studentScholarshipId: number, public user: string) {}
  }
  
  @logDispatcher
  export class DeleteStudentScholarshipSuccess {
    static readonly type = '[Scholarships] DeleteStudentScholarshipSuccess';
    constructor(
      public studentId: number,
      public studentScholarshipId: number
    ) {}
  }

  @logDispatcher
  export class SetStudentScholarshipDefaultState {
    static readonly type = '[Scholarships] SetStudentScholarshipDefaultState';
    constructor() {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Scholarships] Error';
    constructor(public error: any) {}
  }

}
